"use strict";
/*
 * Created on 9. 1. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Error codes/subcodes for releases.
 * @author Radek Beran
 */

var ReleaseErrors = function ReleaseErrors() {
  _classCallCheck(this, ReleaseErrors);
};

exports.ReleaseErrors = ReleaseErrors;
ReleaseErrors.ALREADY_TERMINATED = 'already-terminated';
ReleaseErrors.ALREADY_APPROVED = 'already-approved';
ReleaseErrors.ALREADY_ASSIGNED = 'already-assigned';
ReleaseErrors.USER_LACKS_THE_ROLE = 'user-lacks-the-role';
ReleaseErrors.EDIT_TRANSITION_MISSING_FOR_ROLE_PREFIX = 'edit-transition-missing-for-role-';
ReleaseErrors.EDIT_PRICES_FAILED = 'editPrices-failed';
ReleaseErrors.ABANDON_EDITATION_FAILED = 'abandonEditation-failed';
ReleaseErrors.RELEASE_NOT_EDITABLE = 'releaseNotEditable';